/* eslint no-unused-vars: off, @typescript-eslint/no-unused-vars: off */
/**
 * Monitoring API
 * Monitoring API for working with device errors
 *
 * The version of the OpenAPI document: 1.20.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {
    HardwareErrorIncident,
    Incident,
    ResponseReason,
    UnexpectedResetErrorIncident,
} from './';

/**
 * Response with list of incidents
 * @export
 * @interface ResponseIncidentListBody
 */
export interface ResponseIncidentListBody {
    /**
     * @type {Array<Incident | UnexpectedResetErrorIncident | HardwareErrorIncident>}
     * @memberof ResponseIncidentListBody
     */
    data?: Array<Incident | UnexpectedResetErrorIncident | HardwareErrorIncident>;
    /**
     * @type {string}
     * @memberof ResponseIncidentListBody
     */
    message?: string;
    /**
     * @type {number}
     * @memberof ResponseIncidentListBody
     */
    total?: number;
    /**
     * @type {ResponseReason}
     * @memberof ResponseIncidentListBody
     */
    reason?: ResponseReason;
}
